<template>
  <section class="section">
    <div class="container">
      <div class="message is-danger" v-for="message in errors" v-bind:key="message">
        <div class="message-body">
          {{message}}
        </div>
      </div>
      <h1 class="title">Events</h1>
      <template v-if="events && events.length > 0">
        <article class="media" v-for="event in events" v-bind:key="event">
          <figure class="media-left">
            <p class="image is-64x64">
              <a href="#"><img src="../../assets/128x128.png"></a>
            </p>
          </figure>
          <div class="media-content">
            <div class="content">
              <p>
                <strong>{{event.title}}</strong>&nbsp;
                <small class="has-text-grey">{{event.startDate}} - {{event.endDate}}</small>&nbsp;
                <span class="tag is-success is-light">???</span>&nbsp;
                <br>
                Event update goes here.
              </p>
            </div>
          </div>
        </article>
      </template>
      <template v-else-if="events && events.length == 0">
        <p>No events!</p>
      </template>
      <template v-else>
        <p>Loading...</p>
      </template>
      <h1 class="title">Events (Organized)</h1>
      <template v-if="eventsOrganized && eventsOrganized.length > 0">
        <article class="media" v-for="event in eventsOrganized" v-bind:key="event">
          <figure class="media-left">
            <p class="image is-64x64">
              <a href="#"><img src="../../assets/128x128.png"></a>
            </p>
          </figure>
          <div class="media-content">
            <div class="content">
              <p>
                <strong><router-link :to="`/event/${event.id}`">{{event.title}}</router-link></strong>&nbsp;
                <small class="has-text-grey">{{event.startDate}} - {{event.endDate}}</small>&nbsp;
                <span class="tag is-success is-light">???</span>&nbsp;
                <br>
                Event update goes here.
              </p>
            </div>
          </div>
        </article>
      </template>
      <template v-else-if="eventsOrganized && eventsOrganized.length == 0">
        <p>No events!</p>
      </template>
      <template v-else>
        <p>Loading...</p>
      </template>
      <h1 class="title">Updates</h1>
      <article class="media" v-for="n in 10" v-bind:key="n">
        <figure class="media-left">
          <p class="image is-64x64">
            <a href="#"><img src="../../assets/128x128.png"></a>
          </p>
        </figure>
        <div class="media-content">
          <div class="content">
            <p>
              <strong>Event name {{n}}</strong>&nbsp;
              <small class="has-text-grey">31m ago</small>&nbsp;
              <span class="tag is-success is-light">Attending</span>&nbsp;
              <br>
              Event update goes here.
            </p>
          </div>
        </div>
      </article>
    </div>
    <div class="container">
      <h1 class="title">Debug</h1>
      <div class="notification">
        <p class="title is-6">{{userInfo.username}}</p>
        <button v-on:click="refreshEvents" class="button is-primary">Refresh events</button>
        <button v-on:click="refreshEventsOrganized" class="button is-primary">Refresh organized events</button>
        <pre>{{userInfo.attributes}}</pre>
      </div>
    </div>
  </section>
</template>
<script>
import api from '@/api';

export default {
  name: 'Dashboard',
  props: ['userInfo'],
  data() {
    return {
      events: undefined,
      eventsOrganized: undefined,
      errors: [],
    };
  },
  mounted() {
    this.refreshEvents();
    this.refreshEventsOrganized();
  },
  methods: {
    async refreshEvents() {
      if (await api.guard()) {
        api.get(`/user/${this.userInfo.attributes.sub}/events/rsvp`).then((response) => {
          this.events = response;
        }).catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
          this.errors.push(err);
        });
      }
    },
    async refreshEventsOrganized() {
      if (await api.guard()) {
        api.get(`/user/${this.userInfo.attributes.sub}/events/organized`).then((response) => {
          this.eventsOrganized = response;
        }).catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
          this.errors.push(err);
        });
      }
    },
  },
}
</script>